import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import useLangpackLoader from '@americanexpress/one-identity-components/lib/hooks/useLangpackLoader';
import { getShowIdentityUiPassword } from '../selectors';

const ChangePasswordWrapper = ({
  IdentityUiPassword,
  OneIdentityChangePassword,
  showIdentityUiPassword,
  loadStatus,
  location,
  route,
}) => {
  useLangpackLoader({ moduleName: 'one-identity-root' });

  const eidParam = JSON.parse(sessionStorage.getItem('eidParam')) || {};

  if (loadStatus.all !== 'complete') {
    return null;
  }

  // Check for market flag AND password handling
  return showIdentityUiPassword && !eidParam.legacyPassword
    ? <IdentityUiPassword location={location} />
    : <OneIdentityChangePassword location={location} route={route} />;
};

ChangePasswordWrapper.propTypes = {
  IdentityUiPassword: PropTypes.func.isRequired,
  OneIdentityChangePassword: PropTypes.node.isRequired,
  showIdentityUiPassword: PropTypes.bool.isRequired,
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

export const ComponentToTest = ChangePasswordWrapper;

const loadDataAsProps = ({ store: { dispatch, getState } }) => ({
  IdentityUiPassword: () => dispatch(queryModuleWithData('identity-ui-password')),
  OneIdentityChangePassword: () => dispatch(queryModuleWithData('one-identity-change-password')),
  showIdentityUiPassword: () => ({ status: 'complete', data: getShowIdentityUiPassword(getState()) }),
});

const hocChain = compose(
  oneAppModuleWrapper(ChangePasswordWrapper),
  connectAsync({ loadDataAsProps })
);

export default hocChain(ChangePasswordWrapper);
